"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipInputComponent = void 0;
var React = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var react_merge_refs_1 = __importDefault(require("react-merge-refs"));
var useInputValue_1 = require("../utils/useInputValue");
var useStyles = styles_1.makeStyles(function (_a) {
    var spacing = _a.spacing, typography = _a.typography;
    return styles_1.createStyles({
        root: {
            display: "flex",
            justifyContent: "left",
            flexWrap: "wrap",
            padding: spacing(5.5, 4, 1.5),
            width: "100%",
            overflow: "hidden",
            "& > *": {
                margin: spacing(0.5, 1, 0.5, 0),
                maxWidth: "100%",
            },
        },
        inputWrapper: __assign({ flexGrow: 1, position: "relative", overflow: "hidden" }, typography.body1),
        input: {
            padding: 0,
            height: "auto",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        widthController: {
            visibility: "hidden",
            whiteSpace: "pre",
        },
    });
}, { name: "EuiChipInputComponent" });
var ChipInputComponent = function (_a) {
    var className = _a.className, inputRef = _a.inputRef, chips = _a.chips, props = __rest(_a, ["className", "inputRef", "chips"]);
    var classes = useStyles();
    var localInputRef = React.useRef(null);
    var _b = useInputValue_1.useInputValue(props), value = _b.value, onChange = _b.onChange;
    var manageFocus = React.useCallback(function (_a) {
        var target = _a.target, currentTarget = _a.currentTarget;
        return currentTarget.isSameNode(target) &&
            localInputRef.current &&
            localInputRef.current.focus();
    }, []);
    return (
    // eslint-disable-next-line
    React.createElement("div", { className: classes.root, onClick: manageFocus },
        chips,
        React.createElement("div", { className: classes.inputWrapper },
            React.createElement("input", __assign({ className: clsx_1.default(className, classes.input) }, props, { onChange: onChange, ref: react_merge_refs_1.default([localInputRef, inputRef || null]) })),
            React.createElement("span", { "aria-hidden": "true", className: classes.widthController }, value || " "))));
};
exports.ChipInputComponent = ChipInputComponent;
//# sourceMappingURL=ChipInputComponent.js.map